goog.provide('el8.appservice.banner');

goog.require('el8.template.service.banner');


el8.appservice.banner = (function() {

    return {
        show: function(opts) {
            var that = this;
            var data = {};
            if (opts.color) { data['color'] = opts.color; }
            $('#page-header').after(el8.template.service.banner.content(data));
            var container = $('#page-banner');
            var clickMap = {};
            if (opts.contentFn) {
                $('.banner-contents', container).html(opts.contentFn());
            }
            if (opts.buttons) {
                for (var i=0; i<opts.buttons.length; i++) {
                    $('.banner-buttons', container).append(
                        el8.template.service.banner.button(opts.buttons[i])
                    );
                    clickMap[opts.buttons[i].name] = opts.buttons[i].fn;
                }
            }
            container.on('click', 'button',  function(e) {
                var name = $(this).attr("name");
                if (clickMap[name]) { clickMap[name](); }
                that.hide();
            });
            el8.app.pageLayout.trigger('el8_resizeApp');
        },
        hide: function() {
            var $banner = $('#page-banner');
            $banner.fadeOut(400, function() {
                $banner.remove();
                el8.app.pageLayout.trigger('el8_resizeApp');
            });
        }
    };

})();
